import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import Item from './Item';

export function SortableItem(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({id: props.id});
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Item ref={setNodeRef} {...props} style={style} updateName={props.updateName} isCopying={props.isCopying} copy={props.copy} changeView={props.changeView} {...attributes} {...listeners}>
      {props.id}
    </Item>
  );
}